// app/javascript/packs/nested-forms/addFields.js
class addFields {
    // This executes when the function is instantiated.
    constructor() {
        this.links = document.querySelectorAll('.add_fields')
        this.iterateLinks()
    }

    iterateLinks() {
        // If there are no links on the page, stop the function from executing.
        if (this.links.length === 0) return
        // Loop over each link on the page. A page could have multiple nested forms.
        this.links.forEach(link => {
            // Check if listener already attached to avoid duplicates
            if (link.dataset.listenerAttached === 'true') return

            link.addEventListener('click', e => {
                this.handleClick(link, e)
            })

            // Mark this link as having a listener attached
            link.dataset.listenerAttached = 'true'
        })
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Save a unique timestamp to ensure the key of the associated array is unique.
        let time = new Date().getTime()
        // Save the data id attribute into a variable. This corresponds to `new_object.object_id`.
        let linkId = link.dataset.id
        // Create a new regular expression needed to find any instance of the `new_object.object_id` used in the fields data attribute if there's a value in `linkId`.
        let regexp = linkId ? new RegExp(linkId, 'g') : null
        // Replace all instances of the `new_object.object_id` with `time`, and save markup into a variable if there's a value in `regexp`.
        let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null
        // Add the new markup to the form if there are fields to add.
        newFields ? link.insertAdjacentHTML('beforebegin', newFields) : null

        // Initialize autocomplete ONLY on the newly added field
        var newInputId = "logbook_works_attributes_" + time + "_name";
        var $newInput = $("#" + newInputId);

        console.log("Initializing autocomplete for newly added field:", newInputId);

        if ($newInput.length > 0) {
            var options = {
                url: function(phrase) {
                    console.log("Fetching results for new field, phrase:", phrase);
                    return "/works/search.json?q=" + phrase;
                },
                getValue: "name",
                list: {
                    onSelectItemEvent: function() {
                        console.log("onSelectItemEvent triggered for new field");
                        var selectedData = $newInput.getSelectedItemData();
                        console.log("selectedData:", selectedData);

                        if (!selectedData) {
                            console.log("No selected data");
                            return;
                        }

                        var name = selectedData.name;
                        var description = selectedData.description;
                        var ad = selectedData.ad;

                        console.log("Setting values for time:", time);
                        $("#logbook_works_attributes_"+ time + "_name").val(name).trigger("change");
                        $("#logbook_works_attributes_"+ time + "_description").val(description).trigger("change");
                        $("#logbook_works_attributes_"+ time + "_ad_id").val(ad).trigger("change");
                    }
                }
            };
            $newInput.easyAutocomplete(options);
        }
    }
}

// Initialize on page load
function initAddFields() {
    new addFields();
}

// Wait for turbo/turbolinks to load, otherwise `document.querySelectorAll()` won't work
window.addEventListener('turbo:load', initAddFields);
window.addEventListener('turbo:render', initAddFields);
window.addEventListener('turbo:frame-load', initAddFields);
window.addEventListener('turbolinks:load', initAddFields);
document.addEventListener('DOMContentLoaded', initAddFields);

// Also run immediately if document is already loaded
if (document.readyState === 'loading') {
    // Document still loading, wait for DOMContentLoaded
} else {
    // Document already loaded, run immediately
    initAddFields();
}

export default addFields;
